import React from 'react'
import { useTranslation } from 'react-i18next'
import { Grid } from '@mui/material'
import { muiTheme } from '@pbt/pbt-ui-components'

import BusinessShareIcon from '~/components/common/icons/BusinessShareIcon'
import Link from '~/components/common/link/Link'
import type { QuestionTimelineItemEntry } from '~/types'
import useIsCurrentContextItem from '~/utils/useIsCurrentContextItem'

import AnswerList from './AnswerList'

interface OneQuestionProps {
  enableBusinessShareIcon?: boolean
  hidePadding?: boolean
  question: QuestionTimelineItemEntry[]
  showAppointmentButton?: boolean
}

const OneQuestion = ({
  enableBusinessShareIcon,
  hidePadding,
  question,
  showAppointmentButton,
}: OneQuestionProps) => {
  const { t } = useTranslation(['Common', 'Clients'])

  const { appointmentId, businessId } = question[0]

  const isContextItem = useIsCurrentContextItem({ businessId })

  const isAppointmentButtonVisible =
    isContextItem && showAppointmentButton && Boolean(appointmentId)

  return (
    <Grid
      container
      direction="column"
      pb={1}
      sx={{
        pl: hidePadding ? 0 : muiTheme.spacing(2),
        pr: hidePadding ? 0 : muiTheme.spacing(2),
      }}
    >
      <Grid container item>
        <Grid container item xs alignItems="center" wrap="nowrap">
          <AnswerList entries={question} />
          {enableBusinessShareIcon && (
            <BusinessShareIcon businessIds={[businessId]} />
          )}
        </Grid>
      </Grid>
      {isAppointmentButtonVisible && (
        <Grid container item justifyContent="flex-end" mt={2}>
          <Grid item>
            <Link to={`/scheduler/schedule/${appointmentId}`}>
              {t('Common:VIEW_APPOINTMENT')}
            </Link>
          </Grid>
        </Grid>
      )}
    </Grid>
  )
}

export default OneQuestion
